






























































import {Component, Mixins, Prop, Ref, Watch} from 'vue-property-decorator';
import ErrorAnimation from '@/mixins/ErrorAnimation';

@Component({})
export default class Select extends Mixins(ErrorAnimation) {
	@Prop({default: null}) readonly variant?: string | null;
	@Prop({default: () => ([])}) readonly classes?: Array<string>;
	@Prop({required: true}) readonly options: { label: string, value: any, tabIndex: number }[];
	@Prop({required: false}) readonly label?: string;
	@Prop({required: false}) readonly required?: boolean;
	@Prop({default: false}) readonly disabled?: boolean;
	@Prop({default: null}) readonly tabIndex?: number;
	@Prop({required: false}) readonly defaultOption?: any;

	@Ref('select') selectRef: HTMLElement;
	@Ref('selectedOptionWrapper') selectedOptionWrapper: HTMLElement;

	fieldName: string = `select@${Math.random()}`;

	isValid: boolean = true;
	value: any = null;

	get valueLabel(): string {
		return this.options.find(option => option.value === this.value)!.label;
	}

	get classList(): Array<string | null> {
		return [
			'select',
			this.variant ? `select--${this.variant}` : null,
			this.disabled ? 'select--disabled' : null,
			...(this.classes || [])
		];
	}

	@Watch('value')
	onCheckedChanged(newValue: any): void {
		this.isValid = true;

		this.$emit('input', newValue);
	}

	@Watch('defaultOption')
	onDefaultOptionChanged(newValue: any): void {
		this.value = newValue;
	}

	created(): void {
		if (this.defaultOption) {
			this.value = this.defaultOption;
		}
	}

	async mounted(): Promise<void> {
		if (typeof window === 'undefined') {
			return;
		}
		if (this.variant !== 'filter') {
			return;
		}
	}

	validate(): boolean {
		if (!this.required) {
			return this.isValid;
		}

		this.isValid = !!this.value;

		return this.isValid;
	}

}
